export const DEFAULT_COLUMN_SIZE = 150;
